import { Button } from '@core/ui';

import { AddPollAnswerButtonProps } from './types';

export function AddPollAnswerButton({ children, ...props }: AddPollAnswerButtonProps) {
    return (
        <Button data-testid="add-poll-answer-button-test" variant="primary" classNames="w-10 h-10 rounded-full! px-0! group" type="button" {...props}>
            {children}
        </Button>
    );
}
